import React from 'react';
import { connect } from 'react-redux';
import { getBrokenPoints } from '../../redux/selectors/ingestStats';
import { capitalize } from '../../utils/strings';
import { Row } from '../util/Page';
import PointReadingAges from './graphs/PointReadingAges';
import PointSampleRate from './graphs/PointSampleRate';

import './data-quality-widget.css';

const Stat = ({ name, data: { percent } }) => (
  <div className="status">
    <div>{capitalize(name)}</div>
    <div className={`number ${name}`}>{percent}%</div>
  </div>
);

const DataQualityWidget = ({ buildings, stats: { active, error, stale } }) => (
  <>
    <Row className="data-quality-stats">
      <Stat name="active" data={active} />
      <Stat name="error" data={error} />
      <Stat name="stale" data={stale} />
    </Row>
    <Row className="data-quality-widget">
      <PointSampleRate buildings={buildings} />
    </Row>
    <Row className="data-quality-widget">
      <PointReadingAges buildings={buildings} />
    </Row>
  </>
);

export default connect((state, { buildings }) => {
  const {
    entities: {
      points: { staleIdsByBuilding, byBuilding },
    },
  } = state;
  // organize data by point status, building & equipment type
  /* eslint-disable no-param-reassign */
  const pointStatus = buildings.reduce(
    (status, bid) => {
      // the api gives us stale points
      const stale = staleIdsByBuilding[bid] || [];
      const seen = new Set(stale);

      // broken points have a recent error message
      const { pointsWithMessages, latestTimestamp } = getBrokenPoints(state, bid);
      const brokenPointIds = pointsWithMessages
        .filter(([, message]) => message.timestamp >= latestTimestamp || latestTimestamp == null)
        .map(([point]) => point.id);
      brokenPointIds.forEach((id) => seen.add(id));

      // finally, find the active points by elimination
      const active = (byBuilding[bid] ?? []).filter((pid) => !seen.has(pid));

      status.active += active.length;
      status.error += brokenPointIds.length;
      status.stale += stale.length;

      return status;
    },
    { active: 0, error: 0, stale: 0 }
  );

  const totalPoints = Object.values(pointStatus).reduce((n, c) => n + c, 0);
  const stats = Object.entries(pointStatus).reduce((o, [status, val]) => {
    o[status] = {
      num: val,
      denom: totalPoints,
      percent: ((100 * val) / Math.max(totalPoints, 1)).toFixed(1),
    };
    return o;
  }, {});

  return { stats };
})(DataQualityWidget);
